import MenuIcon from "@mui/icons-material/Menu";
import { grey } from "designSystem/styles/color";
import { Box, ColorChip, CsiImage, FlexRowCenter, GridColumn, GridRow, OverflowText, Select, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { PRODUCT_PRESENTATION_SET } from "../PPService";
import { PickProductComponent } from "./PPResolution";
import { ResolutionColorItem, usePPValidationStore } from "./PPValidationStore";

export interface ColorViolationSingleItemProps {
	/** invalid item */
	item: ResolutionColorItem;
}

const ColorViolationSingleItem: FunctionComponent<ColorViolationSingleItemProps> = observer((props) => {
	const { item } = props;
	const {
		actionOptions,
		color,
		colorImage,
		isEmptyColor,
		productColorItem,
		selectProduct,
		sets,
		showComponentForColor,
	} = item;

	const {
		colorDataStore,
		colorItemUrl,
		productUrl,
		setColorItemUrl,
	} = productColorItem || {};

	const { showActionToReplaceIndividually, supportColor } = usePPValidationStore();
	const loc = useLocale();

	const textForColor = isEmptyColor ? loc.resource("Default") : color.$Name;
	const numberTextForSet = loc.numberOfType(sets.length, PRODUCT_PRESENTATION_SET);

	return (
		<GridColumn spacing={5}>
			{supportColor && (
				<GridRow item>
					<FlexRowCenter position="relative">
						<ColorChip isDefault={isEmptyColor} src={colorImage} />
						<Box ml={1}>
							<OverflowText bold text={textForColor} />
						</Box>
					</FlexRowCenter>
				</GridRow>
			)}
			{showActionToReplaceIndividually && (
				<GridRow item>
					<GridColumn style={{ width: 408 }}>
						<Select
							fullWidth
							items={actionOptions}
							onSelectItem={item.setActionIndex}
							startIcon={<MenuIcon color="action" />}
							value={item.actionIndex}
						/>
					</GridColumn>
				</GridRow>
			)}
			{showActionToReplaceIndividually && showComponentForColor && (
				<GridRow item>
					<PickProductComponent
						colorDataStore={colorDataStore}
						colorUrl={colorItemUrl}
						onSelectColor={setColorItemUrl}
						onSelectProduct={selectProduct}
						productUrl={productUrl}
					/>
				</GridRow>
			)}
			<GridColumn item>
				<GridRow item>
					<FlexRowCenter mb={1}>
						<OverflowText res="PresentationValidationCenterTitleForUsedInSets" resParams={[numberTextForSet]} />
					</FlexRowCenter>
				</GridRow>
				<GridRow
					flexWrap="nowrap"
					item
					scroll
					spacing={5}
					// add the width=100% to avoid the horizontal scroll bar appear for no reason
					style={{ paddingBottom: 16, width: "100%" }}
				>
					{sets.map((set) => (
						<GridColumn
							item
							key={set.$URL}
							spacingAround={3}
							standardBorder
							style = {{ width: 205 }}
						>
							<CsiImage
								aspectRatio={1}
								noImageComponent={(
									<Text
										lineHeight={16}
										res="NoImageAvailable"
										semiBold
										size={14}
										style={{ color: grey[800] }}
									/>
								)}
								node={set}
								width={205}
							/>
							<OverflowText text={set.$Name} />
						</GridColumn>
					),
					)}
				</GridRow>
			</GridColumn>
		</GridColumn>
	);
});

export default ColorViolationSingleItem;